// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xfdI821QpM4gFre_{display:inline-block}.xfdI821QpM4gFre_ .qfSLYMLNggMtAfH2{margin:0 auto;padding:8px;border-radius:32px;background-color:var(--py-neutral-1)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `xfdI821QpM4gFre_`,
	"icon": `qfSLYMLNggMtAfH2`
};
export default ___CSS_LOADER_EXPORT___;
